import React, { createContext, useContext, useReducer } from 'react';

const INITIAL_STATE = {
  latestDrawStatus: null
}

const Context = createContext();

const reducer = (state, action) => {
  if (!action) return state
  switch (action.type) {
    case 'SET_LATEST_DRAW_STATUS':
      return { ...state, latestDrawStatus: action.latestDrawStatus }
    default:
      return { ...state, [action.type]: action[action.type] }
  }
}

export const Provider = ({ children }) => (
  <Context.Provider value={ useReducer(reducer, INITIAL_STATE) }>
    { children }
  </Context.Provider>
);

const State = () => useContext(Context);

export default State;